/**
 * A deal's value in the caller's display currency, as a small line under the
 * real one: "≈ 2 500 Kč", with the rate's day in the tooltip. Renders nothing
 * when there is nothing to convert, and says so plainly when there is no rate
 * — never a number counted at 1.
 */
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import type { ConvertedValueDto } from '@forsys/shared';
import { formatDay, formatMoney } from './format';

export function ConvertedValue({ converted }: { converted: ConvertedValueDto | null }) {
  const { t } = useTranslation('crm');
  if (converted === null) return null;

  if (converted.value === null) {
    return (
      <Typography variant="caption" color="warning.main" component="div">
        {t('converted.noRate', { currency: converted.currency })}
      </Typography>
    );
  }
  return (
    <Typography
      variant="caption"
      color="text.secondary"
      component="div"
      title={converted.rateDate ? t('converted.atRateOf', { date: formatDay(converted.rateDate) }) : undefined}
    >
      ≈ {formatMoney(converted.value, converted.currency)}
    </Typography>
  );
}
